import Landing from '@App/pages/Landing/Landing';

const routes = [
  { name: 'Landing', path: '/', element: <Landing /> },
];

export default routes;